export enum BadgeStyle {
  gray = 'gray',
  teal = 'teal',
  brown = 'brown',
  grayLight = 'grayLight',
}

export enum BadgeSize {
  sm = 'sm',
  md = 'md',
}
